// TODO generate this config at build time by reading values from env variables or buildspec
// calling out to the orsnn-app-api-<stage> stack to get the values
const config = {
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://l8yxs8vdy8.execute-api.us-west-2.amazonaws.com/prod/graphql',
  },
  logs: {
    REGION: 'us-west-2',
    URL: 'https://l8yxs8vdy8.execute-api.us-west-2.amazonaws.com/prod/log',
  },
  cognito: {
    REGION: 'us-west-2',
    USER_POOL_ID: 'us-west-2_B37QdsBr8',
    APP_CLIENT_ID: 'e2k84nq1f1ruv4snrjha2ac43',
    IDENTITY_POOL_ID: 'us-west-2:d21d71cd-2dc9-40db-a55e-71d405752bfe',
  },
  fileGateway: {
    REGION: 'us-west-2',
    URL: 'https://l8yxs8vdy8.execute-api.us-west-2.amazonaws.com/prod/files',
  },
  smartHeaderGateway: {
    REGION: 'us-west-2',
    URL: 'https://l8yxs8vdy8.execute-api.us-west-2.amazonaws.com/prod/smart_header_mapping',
  },
  website: {
    URL: 'https://www.orsnn-sandbox-soumyasanyal.orsnn.com',
  },
  pinpoint: {
    REGION: 'us-west-2',
    APP_ID: 'c074ee7f8a68424a98527a0ae30ace90',
  },
} as const;

export default config;
